<template>
  <div class="flex flex-col gap-2 mt-10 mb-8">
    <div class="flex items-center justify-between mb-4">
      <h4 class="mb-2">
        {{
          $t("labels.generic", {
            pt: "Feedbacks escritos",
            en: "Written feedback",
          })
        }}
      </h4>
      <Button
        :label="$t('labels.generic', { pt: 'Baixar', en: 'Download' })"
        icon="pi pi-download"
        class="p-button-sm btn-primary h-9"
        :loading="btnLoading"
        @click="downloadCSV"
      />
    </div>
    <div
      class="bg-white rounded-lg border border-gray-300 w-[500px] lg:w-full !overflow-x-auto"
    >
      <Table
        :slotData="draftsFeedbacks"
        :columns="columns"
        :loading="loader"
        :params="params"
        :filters="filters"
        :hasStatus="false"
        :actionsTitle="$t('labels.generic', { pt: 'Detalhes', en: 'Details' })"
        @onGoTo="(e) => openModal(e)"
        :actions="actions"
        @onPaginate="paginate($event)"
      >
      </Table>
    </div>

    <Dialog
      v-model:visible="displayModal"
      :header="
        $t('labels.generic', {
          pt: 'Nome do objetivo - ',
          en: 'Objective name - ',
        })?.concat(currentObjective?.name ?? '')
      "
      :draggable="false"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '40vw' }"
      :modal="true"
      class="custom-modal"
    >
      <div class="mt-4">
        <p class="text-neutral-900">
          <span class="font-[700]"
            >{{
              $t("labels.generic", {
                pt: "Nome: ",
                en: "Name: ",
              })
            }}
          </span>
          {{ currentDraftFeedback.completeUserName ?? " - " }}
        </p>
        <p class="text-neutral-900">
          <span class="font-[700]"
            >{{
              $t("labels.generic", {
                pt: "E-mail: ",
                en: "E-mail: ",
              })
            }}
          </span>
          {{ currentDraftFeedback.completeUserEmail ?? " - " }}
        </p>
        <p class="text-neutral-900 mt-2">
          <span class="font-[700]"
            >{{
              $t("labels.generic", {
                pt: "Mensagem: ",
                en: "Message: ",
              })
            }}
          </span>
          {{ currentDraftFeedback.feedbackText ?? " - " }}
        </p>
      </div>
    </Dialog>
  </div>
</template>

<script lang="ts">
import { QueryParams } from "@/models/query-params.model";
import { DraftFeedbackObjective } from "@/models/stats.model";
import { StatsRest } from "@/services/rest/stats.rest";
import { draftsFeedbackStatsObjective } from "@/views/Stats/Objective/DraftsFeedbacks/drafts-feedbacks.utils";
import saveAs from "file-saver";
import { delay, last, take } from "rxjs";
import { defineComponent } from "vue";
import { DraftsFeedbacksService } from "./drafts-feedbacks.service";

export default defineComponent({
  name: "drafts-feedbacks",
  computed: {
    service(): DraftsFeedbacksService {
      return new DraftsFeedbacksService();
    },
    rest(): StatsRest {
      return new StatsRest();
    },
    classroomId(): string {
      return String(localStorage.getItem("objClassroomId"));
    },
  },
  mounted() {
    this.courseId = String(this.$route.params.courseId);
    this.objectiveId = String(this.$route.params.objectiveId);
    this.draftsFeedbackPaginated();
  },
  props: {
    currentObjective: [Object],
  },
  data() {
    return {
      columns: draftsFeedbackStatsObjective,
      actions: [
        {
          title: "Ver detalhes",
          icon: "hi-chevron-right",
          type: "goTo",
          style: "btn-outline",
        },
      ],
      params: new QueryParams(),
      filters: {
        isCleareable: false,
        name: null,
      } as any,
      draftsFeedbacks: [] as DraftFeedbackObjective,
      loader: true as boolean,
      btnLoading: false as boolean,
      objectiveId: "" as string,
      courseId: "" as string,
      displayModal: false as boolean,
      currentDraftFeedback: new DraftFeedbackObjective(),
    };
  },
  watch: {
    $route(val) {
      if (this.$route.name === "statsObjective") {
        this.objectiveId = val.params.objectiveId;
        this.draftsFeedbackPaginated();
      }
    },
  },
  methods: {
    paginate(event: { page: number; rows: number }): void {
      const params = new QueryParams(event.page, event.rows);
      params.name = this.filters.name;
      this.getDraftsFeedbacksFromObjective(params);
    },
    draftsFeedbackPaginated(): void {
      const page = this.params.page;
      const size = this.params.size;
      const params = new QueryParams(page, size);
      this.getDraftsFeedbacksFromObjective(params);
    },
    getDraftsFeedbacksFromObjective(queryParams: QueryParams): void {
      this.service.draftsFeedbacks.pipe(take(2), last()).subscribe({
        next: (response: any) => {
          this.loader = false;
          this.draftsFeedbacks = response.content;
          this.params.total = response.total;
        },
        error: () => {
          this.loader = false;
        },
      });
      this.service.getDraftsFeedbacksFromObjective(
        this.courseId,
        this.objectiveId,
        queryParams
      );
    },
    downloadCSV(): void {
      this.btnLoading = true;
      this.rest
        .getDraftsFeedbacksStatsCsv(this.courseId, this.objectiveId, {
          classroomId: this.classroomId,
        })
        .pipe(delay(1000))
        .subscribe({
          next: (response) => {
            this.btnLoading = false;
            const blob = new Blob([response], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);
            saveAs(url, `written_feedback_data.csv`);
          },
          error: () => {
            this.btnLoading = false;
          },
        });
    },
    openModal(draftsFeedback: any): void {
      this.currentDraftFeedback = draftsFeedback;
      this.displayModal = true;
    },
  },
});
</script>
